import axios from 'axios';

const server = process.env.REACT_APP_SERVER_URL;

// --- Reset Password Utilities ---
export interface UsuarioResetPassword {
  id_usuario: number;
  nombre_completo: string;
  nombre_de_usuario: string;
  bloqueado: boolean;
}

export const searchResetPasswordUsers = async (usuario: string): Promise<UsuarioResetPassword[]> => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${server}/utilidades/reset-password`, {
    params: { usuario },
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const resetUserPassword = async (id_usuario: number): Promise<string> => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${server}/utilidades/reset-password/${id_usuario}`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data?.message || 'Contraseña reseteada con éxito';
};

export interface CreateFiscalCreditPayload {
  tipo_documento: string;
  numero_documento: string;
  tipo_credito: 'NATURAL' | 'JURIDICO';
  rim?: string;
  monto_credito: number;
}

export interface AdjustSettlementAmountPayload {
  idSolicitud: number;
  monto: number;
}

export interface AdjustSettlementAmountResponse {
  ok: boolean;
  message: string;
  data?: {
    idSolicitud: number;
    cantidadLiquidaciones: number;
    montoPetroPorLiquidacion: number;
  };
}

export interface SupportSettlement {
  id_liquidacion: number;
  id_solicitud: number;
  fecha_liquidacion: string;
  fecha_vencimiento: string;
  id_registro_municipal: number | null;
  referencia_municipal?: string | null;
  monto_petro: number;
}

export interface SearchSettlementsResponse {
  ok: boolean;
  message: string;
  liquidaciones: SupportSettlement[];
}

export interface UpdateSettlementPayload {
  id_liquidacion: number;
  fecha_liquidacion: string;
  fecha_vencimiento: string;
  referencia_municipal?: string;
}

export interface UpdateSettlementResponse {
  ok: boolean;
  message: string;
  liquidacion?: SupportSettlement;
}

export const createFiscalCredit = async (payload: CreateFiscalCreditPayload) => {
  try {
    const response = await axios.post(`${server}/utilidades/cargar-credito`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const adjustSettlementAmount = async (
  payload: AdjustSettlementAmountPayload
): Promise<AdjustSettlementAmountResponse> => {
  try {
    const response = await axios.post(
      `${server}/utilidades/ajustar-monto-liquidacion`,
      {
        idSolicitud: payload.idSolicitud,
        id_solicitud: payload.idSolicitud,
        monto: payload.monto,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchSettlementsByRequest = async (idSolicitud: number): Promise<SearchSettlementsResponse> => {
  try {
    const response = await axios.get(`${server}/utilidades/liquidaciones/search`, {
      params: {
        idSolicitud,
        id_solicitud: idSolicitud,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSettlementFields = async (
  payload: UpdateSettlementPayload
): Promise<UpdateSettlementResponse> => {
  try {
    const response = await axios.put(
      `${server}/utilidades/liquidaciones/${payload.id_liquidacion}`,
      {
        ...payload,
        idLiquidacion: payload.id_liquidacion,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
